import { observer } from 'mobx-react';
import { FC } from 'react';
import SmsPlatformControls from '../../components/SmsPlatformControls/SmsPlatformControls';
import takerConnectStore from '../../store/takerConnectStore';
import { ConnectionService } from '../../types/takerConnect';
import { localeStore } from '~/mobx/localesStore';
import { TBooleanInNumber } from '~/types/main';
import Input from '~/view/components/Controls/InputComponent/Input';
import Text, { TEXT } from '~/view/components/Text/Text';

const Msegat: FC = observer((): JSX.Element => {
  const { senderName, userName, status, priority, apiKey } = takerConnectStore.services.get(ConnectionService.Msegat) || {
    senderName: '',
    userName: '',
    status: 1,
    priority: '',
    apiKey: '',
  };
  const { senderName: senderNameError, userName: userNameError } = takerConnectStore.validationErrors;

  const handleStatusChange = (status: TBooleanInNumber) => {
    takerConnectStore.changeServiceData(ConnectionService.Msegat, { status });
  };

  const handlePriorityChange = (value: string | undefined) => {
    takerConnectStore.changeServiceData(ConnectionService.Msegat, { priority: value });
  };

  const handleSmsKeyChange = (value: string | undefined) => {
    takerConnectStore.changeServiceData(ConnectionService.Msegat, { apiKey: value });
  };

  const handleSenderChange = (value: string | undefined) => {
    takerConnectStore.changeServiceData(ConnectionService.Msegat, { senderName: value });

    if (value && senderNameError) {
      takerConnectStore.validateSenderName(value);
    }
  };

  const handleUsernameChange = (value: string | undefined) => {
    takerConnectStore.changeServiceData(ConnectionService.Msegat, { userName: value });

    if (value && userNameError) {
      takerConnectStore.validateUserName(value);
    }
  };

  return (
    <div>
      <SmsPlatformControls
        type={ConnectionService.Msegat}
        status={status}
        smsKey={apiKey}
        priority={priority}
        onStatusChange={handleStatusChange}
        onPriorityChange={handlePriorityChange}
        onSmsKeyChange={handleSmsKeyChange}
      />

      {status ? (
        <div className="d-flex gap-20 mt-5">
          <div className="w-50">
            <Text type={TEXT.BLOCK_HEADER} text={localeStore.t('sender')} required />
            <Input
              value={senderName}
              onChangeValue={handleSenderChange}
              validation={{ isValid: senderNameError === null, errorText: senderNameError }}
              className="mt-2"
              contentClassName="full-width"
            />
          </div>

          <div className="w-50">
            <Text type={TEXT.BLOCK_HEADER} text={localeStore.t('username')} required />
            <Input
              value={userName}
              onChangeValue={handleUsernameChange}
              validation={{ isValid: userNameError === null, errorText: userNameError }}
              className="mt-2"
              contentClassName="full-width"
            />
          </div>
        </div>
      ) : null}
    </div>
  );
});

export default Msegat;
